import { memo } from 'react';

import SvgIcon from '@material-ui/core/SvgIcon';

import { colors } from '../theme';
import { SvgIconProps } from './SvgIcon.types';

export const ReportingIcon = memo(({ className, color = colors.basic.black }: SvgIconProps) => (
  <SvgIcon className={className} width="16" height="17" viewBox="0 0 16 17" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.28564 14.4712C1.28564 14.195 1.5095 13.9712 1.78564 13.9712H14.2856C14.5618 13.9712 14.7856 14.195 14.7856 14.4712C14.7856 14.7473 14.5618 14.9712 14.2856 14.9712H1.78564C1.5095 14.9712 1.28564 14.7473 1.28564 14.4712Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.38203 11.0317C2.55299 10.8892 2.77672 10.8047 3.00768 10.8047H4.67434C4.90113 10.8047 5.13462 10.887 5.30929 11.0458C5.4811 11.202 5.60782 11.4506 5.56323 11.7409V14.4714C5.56323 14.7475 5.33937 14.9714 5.06323 14.9714H2.56323C2.28709 14.9714 2.06323 14.7475 2.06323 14.4714V11.6936C2.06323 11.4057 2.20848 11.1763 2.38203 11.0317ZM3.06323 11.8047V13.9714H4.56323V11.8047H3.06323ZM4.67212 11.8047C4.67272 11.8047 4.67325 11.8047 4.67373 11.8047C4.67395 11.8047 4.67415 11.8047 4.67434 11.8047H4.67212Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.54878 7.03169C6.71974 6.88922 6.94347 6.80469 7.17443 6.80469H8.84109C9.33946 6.80469 9.72998 7.19521 9.72998 7.69358V14.4714C9.72998 14.7475 9.50612 14.9714 9.22998 14.9714H6.72998C6.45384 14.9714 6.22998 14.7475 6.22998 14.4714V7.69358C6.22998 7.40568 6.37523 7.17631 6.54878 7.03169ZM7.22998 7.80469V13.9714H8.72998V7.80469H7.22998Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.7155 9.42036C10.8865 9.27789 11.1102 9.19336 11.3412 9.19336H13.0078C13.2346 9.19336 13.4681 9.27571 13.6428 9.4345C13.8146 9.59069 13.9413 9.83922 13.8967 10.1295V14.4711C13.8967 14.7473 13.6729 14.9711 13.3967 14.9711H10.8967C10.6206 14.9711 10.3967 14.7473 10.3967 14.4711V10.0822C10.3967 9.79435 10.542 9.56498 10.7155 9.42036ZM11.3967 10.1934V13.9711H12.8967V10.1934H11.3967ZM13.0056 10.1934C13.0062 10.1934 13.0067 10.1934 13.0072 10.1934C13.0074 10.1934 13.0076 10.1934 13.0078 10.1934H13.0056Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.22998 7.74897C1.22998 6.9846 1.88864 6.47119 2.56331 6.47119C3.23799 6.47119 3.89665 6.9846 3.89665 7.74897C3.89665 8.51333 3.23799 9.02675 2.56331 9.02675C1.81005 9.02675 1.31654 8.39043 1.23501 7.81968C1.23166 7.79626 1.22998 7.77263 1.22998 7.74897ZM2.23256 7.71661C2.25129 7.79091 2.29371 7.86948 2.35437 7.93014C2.42217 7.99794 2.49441 8.02675 2.56331 8.02675C2.77753 8.02675 2.89665 7.87349 2.89665 7.74897C2.89665 7.62444 2.77753 7.47119 2.56331 7.47119C2.36736 7.47119 2.25098 7.59943 2.23256 7.71661Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.00781 3.30463C5.00781 2.54027 5.66647 2.02686 6.34115 2.02686C7.01582 2.02686 7.67448 2.54027 7.67448 3.30463C7.67448 4.069 7.01582 4.58241 6.34115 4.58241C5.66647 4.58241 5.00781 4.069 5.00781 3.30463ZM6.34115 3.02686C6.12693 3.02686 6.00781 3.18011 6.00781 3.30463C6.00781 3.42916 6.12693 3.58241 6.34115 3.58241C6.55536 3.58241 6.67448 3.42916 6.67448 3.30463C6.67448 3.18011 6.55536 3.02686 6.34115 3.02686Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.1192 5.27399C12.1366 4.52658 12.7866 4.02686 13.4522 4.02686C14.1269 4.02686 14.7855 4.54027 14.7855 5.30463C14.7855 6.069 14.1269 6.58241 13.4522 6.58241C13.0946 6.58241 12.7474 6.46334 12.4909 6.23016C12.2341 5.99671 12.0815 5.65699 12.1192 5.27399ZM13.4522 5.02686C13.238 5.02686 13.1189 5.18011 13.1189 5.30463C13.1189 5.32537 13.1176 5.34608 13.115 5.36665C13.1089 5.4153 13.1218 5.45225 13.1635 5.49022C13.2126 5.53481 13.3098 5.58241 13.4522 5.58241C13.6664 5.58241 13.7855 5.42916 13.7855 5.30463C13.7855 5.18011 13.6664 5.02686 13.4522 5.02686Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.16707 3.53638C6.37647 3.71639 6.4003 4.03208 6.22029 4.24148L3.49806 7.40815C3.31805 7.61755 3.00237 7.64137 2.79296 7.46136C2.58356 7.28135 2.55973 6.96566 2.73975 6.75626L5.46197 3.58959C5.64198 3.38019 5.95767 3.35636 6.16707 3.53638Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.63765 3.39091C6.71281 3.12519 6.98914 2.9707 7.25486 3.04586L12.7549 4.60141C13.0206 4.67656 13.1751 4.9529 13.0999 5.21862C13.0248 5.48433 12.7484 5.63882 12.4827 5.56367L6.9827 4.00811C6.71698 3.93296 6.5625 3.65663 6.63765 3.39091Z"
      fill={color}
    />
  </SvgIcon>
));
